// extracted by mini-css-extract-plugin
export var body = "_kv-0";
export var sectionHeader = "_kv-4";
export var shortcutColumns = "_kv-2";
export var shortcutList = "_kv-1";
export var shortcutSection = "_kv-3";